export const FALLBACK_MENU_DATA = {
  mainNav: [],
  tools: { nodes: [] },
  support: { nodes: [] },
}
export const ENVIRONMENTS = ['projectqa', 'qax', 'qae', 'pre-qae', 'pre-qa', 'pre-uat1', 'uat1', 'pre-sit', 'sit', 'pre', 'sim', 'pre-sim']
export const FILTERED_ITEMS_MAP_LOCAL_STORAGE_ID = 'ia-header--filtered-items-map'
export const MENU_DATA_LOCAL_STORAGE_ID = 'ia-header--menu-items'

export const CHECKOUT_ROUTES = {
  LINE_LEVEL: '/editLineLevelInfo',
  SHIP_BILL_PAY: '/shippingOrder',
  PLACE_ORDER: '/reviewOrder',
  PROCESS_ORDER: '/processOrder',
}

export const GUEST_CHECKOUT_ROUTES = {
  CUSTOMER_INFO: '/customerInfo',
  ITEM_INFO: '/lineLevelInfo',
  SHOPPING_INFO: '/shipBill',
  REVIEW: '/review',
  PROCESS: '/process',
}

export const MASTHEAD_ICON_TITLES = {
  TOOLS: 'Tools menu',
  SUPPORT: 'Support menu',
  LOCALE: 'Country and language menu',
  CART: 'Shopping cart',
  SEARCH: 'Search',
  HOMEPAGE: 'Insight homepage',
  INSIGHT_NEWS: 'Insight news',
  ACCOUNT: 'Account menu',
}

export const MASTHEAD_ICON_TITLES_TOOLS = 'Tools menu'
export const MASTHEAD_ICON_TITLES_SUPPORT = 'Support menu'
export const MASTHEAD_ICON_TITLES_LOCALE = 'Country and language menu'
export const MASTHEAD_ICON_TITLES_CART = 'Shopping cart'
export const MASTHEAD_ICON_TITLES_SEARCH = 'Search'
export const MASTHEAD_ICON_TITLES_HOMEPAGE = 'Insight homepage'
export const MASTHEAD_ICON_TITLES_ACCOUNT = 'Account menu'
export const MASTHEAD_ICON_TITLES_INSIGHT_NEWS = 'Insight news'
export const HIDE_LOGGEDOUT_PRICING_BY_SALESORG = "GNA-12455-HIDE-LOGGEDOUT-PRICING-BY-SALESORG"
export const ENABLE_TYPEAHEAD_PRICING = "GNA-16148-TYPEAHEAD_PRICING"
export const ENABLE_NIA = 'GNA-17176-NIA'
export const NIA_ENV = 'GNA-18028-NIA-ENV'

